import { Injectable } from '@angular/core';
import { CreateResult } from '../models/create-result';
import { CustomServicesConfigModel } from '../models/custom-service-config-mode';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class CustomConfigService {

  constructor(private _httpService: HttpService) { }

  public async AddService(service: CustomConfigService): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`service/AddService`, service);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async GetCustomServices(participantId: number): Promise<CustomServicesConfigModel[]> {
    const httpResult = await this._httpService.apiGet<CustomServicesConfigModel[]>(`customService/GetServices/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async getCustomServiceConfigMerchants(merchantNumber: string, serviceId: number): Promise<CustomServicesConfigModel> {
    const httpResult = await this._httpService.apiGet<CustomServicesConfigModel>(`CustomService/GetServicesByMerchantNr/${merchantNumber}/${serviceId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async AddCustomService(service: CustomServicesConfigModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`customService/AddService/${service.participantId}`, service);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddCustomServiceBulk(participantId: number, services: CustomServicesConfigModel[]): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`customService/AddServicesBulk/${participantId}`, services);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async DeleteCustomService(merchantNumber: string, serviceId: number): Promise<void> {
    const httpResult = await this._httpService.apiDelete(`customService/DeleteService/${merchantNumber}/${serviceId}`);
  }
}
